import { sv } from "@dhx/ts-common/dom";
import { getCoordinates } from "../helpers/circle";
import { verticalCenteredText } from "../helpers/common";
import { SvgElement, NoScaleSubType } from "../types";
import NoScaleSeria from "./NoScaleSeria";
export default class Pie extends NoScaleSeria { // todo move to NoScaleSeria
	paint(width: number, height: number): SvgElement {
		const { subType, useLines, showText, showTextTemplate } = this.config;
		const radiusX = height / 2;
		const radiusY = radiusX * .5;
		const connector = radiusX / 5;

		const tooltipData = [];

		let currentPercent = -.25;
		let svg = [];
		const links = [];
		const err = this._points.length === 1 ? -.000001 : 0;

		this._points.forEach(item => {
			const [percent, value, id, text, color] = item;

			const [startX, startY] = getCoordinates(currentPercent, radiusX, radiusY);
			const avPercent = currentPercent + percent / 2;
			const lineLength = avPercent < .25 ? 5 : -5;
			const middleLine = getCoordinates(avPercent, radiusX, radiusY);
			let delta = 0;
			if (avPercent > 0 && avPercent < 0.5) {
				delta = connector * Math.sin(2 * Math.PI * avPercent);
			}
			const linkStart = getCoordinates(avPercent, radiusX + 5 + delta, radiusY + 5 + delta);
			const linkEnd = getCoordinates(avPercent, radiusX + 30 + delta, radiusY + 30 + delta);
			const nextPercent = currentPercent + percent + err;
			const [endX, endY] = getCoordinates(nextPercent, radiusX, radiusY);
			const largeArcFlag = percent > .5 ? 1 : 0;
			const className = avPercent > - 0.25 && avPercent < 0.25 ? "pie-value start-text" : "pie-value end-text";

			if (useLines) {
				links.push(sv("path", {d: `M${linkStart[0]} ${linkStart[1]} L${linkEnd[0]} ${linkEnd[1]} h ${lineLength}`, class: "pie-value-connector"}));
				const textSvg = sv("text", {x: linkEnd[0], y: linkEnd[1], dx: lineLength / 2 + lineLength > 0 ? 10 : -10, class: className}, [
					verticalCenteredText(text.toString())
				]);
				links.push(textSvg);
			} else {
				const textPadding = 10;
				const dy = avPercent > 0.5 || avPercent < 0 ? -textPadding : textPadding;
				const textSvg = sv("text", {x: linkStart[0], y: linkStart[1] + dy, class: className}, [
					verticalCenteredText(text.toString())
				]);
				links.push(textSvg);
			}
			if (showText || showTextTemplate) {
				const textSvg = sv("text", {x: middleLine[0] * .7, y: middleLine[1] * .7, class: "pie-inner-value"}, [
					showTextTemplate ? verticalCenteredText(showTextTemplate(value)) : verticalCenteredText(value.toString())
				]);
				links.push(textSvg);
			}
			if (subType === NoScaleSubType.percentOnly) {
				const percentText = sv("text", {x: middleLine[0] * 0.6, y: middleLine[1] * 0.6, class: "pie-inner-value"}, [
					verticalCenteredText(Math.round(percent * 100) + "%")
				]);
				links.push(percentText);
			}
			// 3d block
			let addition = "";
			if (currentPercent <= 0 && nextPercent >= .5) {
				addition = `M ${radiusX} 0 v ${connector} A ${radiusX} ${radiusY} 0 1 1 ${-radiusX} ${connector} v ${-connector}`;
			} else if (currentPercent <= 0 && nextPercent < .5) {
				addition = `M ${radiusX} 0 v ${connector} A ${radiusX} ${radiusY} 0 0 1 ${endX} ${endY + connector} v ${-connector}`;
			} else if (currentPercent > 0 && currentPercent <= .5 && nextPercent >= .5) {
				addition = `M ${startX} ${startY} v ${connector} A ${radiusX} ${radiusY} 0 0 1 ${-radiusX} ${connector} v ${-connector}`;
			} else if (currentPercent > 0 && nextPercent < .5) {
				addition = `M ${startX} ${startY} v ${connector} A ${radiusX} ${radiusY} 0 0 1 ${endX} ${endY + connector} v ${-connector}`;
			}
			if (addition) {
				const additionPath = sv("path", {
					_key: id+"__shadow__",
					d: addition,
					fill: color,
					class: "chart pie3d addition",
					stroke: "none",
					filter: "url(#shadow)"
				});
				svg.push(additionPath);
			}
			// end 3d block
			const d = `M ${startX} ${startY} A ${radiusX} ${radiusY} 0 ${largeArcFlag} 1 ${endX} ${endY} L 0 0`;
			svg.push(sv("path", {
				d,
				_key: id,
				fill: color,
				stroke: "none",
				class: "chart pie3d"
			}));

			if (this._points.length === 1) {
				tooltipData.push([width / 2, height / 2]);
			} else {
				tooltipData.push([middleLine[0] * .7 + width / 2, middleLine[1] * .7 + height / 2]);
			}

			currentPercent = nextPercent;
		});

		this._center = [width / 2, height / 2];
		this._tooltipData = tooltipData;

		svg = svg.concat(links);
		return sv("g", { transform: `translate(${width / 2}, ${height / 2})` }, svg);
	}
}